import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { m } from '~/paraglide/messages.js';

function getCliCommand() {
  const { hostname } = window.location;
  if (hostname === 'localhost' || hostname === '0.0.0.0') {
    return `npx @bloque/cli setup --web --host ${window.location.origin}`;
  }
  return 'npx @bloque/cli setup --web';
}

export function CliCommandWidget() {
  const cliCommand = getCliCommand();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(cliCommand);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="space-y-3">
      <div className="relative overflow-hidden rounded-xl border border-border bg-muted/50">
        <div className="flex items-center gap-2 border-b border-border px-4 py-2.5">
          <div className="flex gap-1.5">
            <div className="h-2.5 w-2.5 rounded-full bg-red-500/60" />
            <div className="h-2.5 w-2.5 rounded-full bg-yellow-500/60" />
            <div className="h-2.5 w-2.5 rounded-full bg-green-500/60" />
          </div>
          <span className="text-xs text-muted-foreground">Terminal</span>
        </div>
        <div className="flex items-center justify-between gap-3 p-4">
          <code className="flex-1 break-all text-sm text-foreground">
            <span className="text-muted-foreground">$ </span>
            {cliCommand}
          </code>
          <button
            type="button"
            onClick={handleCopy}
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-border bg-background text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
          >
            {copied ? (
              <Check className="h-3.5 w-3.5 text-green-500" />
            ) : (
              <Copy className="h-3.5 w-3.5" />
            )}
          </button>
        </div>
      </div>

      <p className="text-center text-xs text-muted-foreground">
        {m['onboarding.connect_bloque.hint']()}
      </p>
    </div>
  );
}
